
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var DataActionUtil = require("../../../util/DataActionUtil.js");

class EditAssetButton extends React.Component  {
    constructor(){
        super()
    }

    render(){

        return <ActionButton
                    {...this.props}
                    text={ (this.props.current_user_id !== this.props.resource.user_id)?"Inspect":"Edit" }
                    mainClass=""
                    action={DataActionUtil.editAsset}
               />
    }
}

module.exports = EditAssetButton;
